import React from "react";
import { PricingWrapper } from "./PricingElements";

function Pricing() {
  const pdfPackages = [
    {
      title: "Web Development Packages",
      file: "/Web_Development_Packages (1).pdf",
      description: "Detailed pricing for web development services"
    },
    {
      title: "Mobile App Packages",
      file: "/Mobile_App_Packages.pdf",
      description: "Comprehensive mobile application pricing"
    },
    {
      title: "Design Packages",
      file: "/Design_Packages.pdf",
      description: "Graphic design and branding packages"
    }
  ];

  return (
    <PricingWrapper id="pricing">
      <div className="Container">
        <div className="SectionTitle">Pricing</div>

        <div className="pdf-packages-section" style={{ marginTop: '2rem', textAlign: 'center' }}>
          <h3 style={{
            fontSize: '2rem',
            color: '#ffffff',
            marginBottom: '2rem',
            fontWeight: '700'
          }}>
            Detailed Package Information
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: '2rem',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
            {pdfPackages.map((pdf, index) => (
              <div key={index} style={{
                background: 'linear-gradient(135deg, #000000 0%, #333333 100%)',
                borderRadius: '20px',
                padding: '2rem',
                boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                border: '2px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.1)';
              }}
              >
                <h4 style={{
                  fontSize: '1.5rem',
                  color: '#ffffff',
                  marginBottom: '1rem',
                  fontWeight: '600'
                }}>
                  📄 {pdf.title}
                </h4>
                <p style={{
                  color: '#cccccc',
                  marginBottom: '1.5rem',
                  fontSize: '1rem'
                }}>
                  {pdf.description}
                </p>
                <a
                  href={pdf.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn PrimaryBtn"
                  style={{
                    display: 'inline-block',
                    textDecoration: 'none'
                  }}
                >
                  Download PDF
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PricingWrapper>
  );
}

export default Pricing;
